/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IMilestoneDisplayModel {
  beschreibung?: null | string;
  betreff?: null | string;
  datumIst?: null | string;
  datumPlan?: null | string;
  erstelltInPhaseId?: null | string;
  erstelltInProjektBerichtId?: null | string;
  id?: null | string;
  ort?: null | string;
}
export class MilestoneDisplayModel extends BaseModel implements IMilestoneDisplayModel {
  beschreibung?: null | string;
  betreff?: null | string;
  datumIst?: null | string;
  datumPlan?: null | string;
  erstelltInPhaseId?: null | string;
  erstelltInProjektBerichtId?: null | string;
  id?: null | string;
  ort?: null | string;
}
class BaseMilestoneDisplayModelFormGroup extends FormGroup {
  private static _instance: MilestoneDisplayModelFormGroup;
  
  public static get Instance(): MilestoneDisplayModelFormGroup {
    this._instance = new MilestoneDisplayModelFormGroup({
      beschreibung: new FormControl(null),
      betreff: new FormControl(null),
      datumIst: new FormControl(null),
      datumPlan: new FormControl(null),
      erstelltInPhaseId: new FormControl(null),
      erstelltInProjektBerichtId: new FormControl(null),
      id: new FormControl(null),
      ort: new FormControl(null),
    });

    return this._instance;
  }
}


export class MilestoneDisplayModelFormGroup extends BaseMilestoneDisplayModelFormGroup {
  public get Beschreibung(): FormControl {
    return this.controls["beschreibung"] as FormControl;
  }
  public get Betreff(): FormControl {
    return this.controls["betreff"] as FormControl;
  }
  public get DatumIst(): FormControl {
    return this.controls["datumIst"] as FormControl;
  }
  public get DatumPlan(): FormControl {
    return this.controls["datumPlan"] as FormControl;
  }
  public get ErstelltInPhaseId(): FormControl {
    return this.controls["erstelltInPhaseId"] as FormControl;
  }
  public get ErstelltInProjektBerichtId(): FormControl {
    return this.controls["erstelltInProjektBerichtId"] as FormControl;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Ort(): FormControl {
    return this.controls["ort"] as FormControl;
  }
  

}

export module MilestoneDisplayModelForm
  {
    export class FormFields
    {
      static _beschreibung: string = "beschreibung";
      static _betreff: string = "betreff";
      static _datumIst: string = "datumIst";
      static _datumPlan: string = "datumPlan";
      static _erstelltInPhaseId: string = "erstelltInPhaseId";
      static _erstelltInProjektBerichtId: string = "erstelltInProjektBerichtId";
      static _id: string = "id";
      static _ort: string = "ort";
    }
  }

